import React from 'react';
import Relay from 'react-relay/classic';
import ReactDOM from 'react-dom';

import { BrowserProtocol, queryMiddleware } from 'farce';
import {
  createFarceRouter,
  createRender,
  makeRouteConfig,
} from 'found';
import { Resolver } from 'found-relay/lib/classic';

import routes from './routes';
import {BACKEND_URL} from './constants';
import './index.css';


const URL = `${BACKEND_URL}/graphql`;
const environment = new Relay.Environment();
Relay.injectNetworkLayer(new Relay.DefaultNetworkLayer(URL, {
  credentials: 'include',
  fetchTimeout: 30000
}));
environment.injectNetworkLayer(new Relay.DefaultNetworkLayer(URL, {
  credentials: 'include',
  fetchTimeout: 30000
}));

const Router = createFarceRouter({
  historyProtocol: new BrowserProtocol(),
  historyMiddlewares: [queryMiddleware],
  routeConfig:  makeRouteConfig(routes),

  render: createRender({}),
});

function renderAll() {
  ReactDOM.render(
    <Router resolver={new Resolver(environment)} />,
    document.getElementById('root')
  );
}

renderAll();




// WEBPACK FOOTER //
// ./src/index.js